const weekdays = ["S", "M", "T", "W", "T", "F", "S"];

const paymentTypeOptions = [
	{ label: "Gross", value: false, description: "The amount before any deductions or taxes are taken out." },
	{ label: "Net", value: true, description: "Net salary is the take home pay. Choose this option if you want to pay taxes and other deductions on top of this amount." },
];

const salaryPeriodOption = [
	{ label: "Hour", value: 105 },
	{ label: "Day", value: 104 },
	{ label: "Week", value: 103 },
	{ label: "Month", value: 102 },
	{ label: "Year", value: 101 },
	{ label: "Fortnight (Two Weeks)", value: 107 },
	{ label: "Four Weeks", value: 106 },
];

const employmentTypeOption = [
	{ label: "Full-time", value: 501 },
	{ label: "Part-time", value: 502 },
	{ label: "External Contractor", value: 1843110 },
	{ label: "Director", value: "director" },
	// { label: "CIS Contractor", value: "cis-contractor" , jurisdiction: ["UK"]},
	// { label: "Off Payroll Worker", value: "off-payroll-worker", jurisdiction: ["UK"] },
];

const defaultWorking = {
	"501": { days: ["2", "3", "4", "5", "6"], hours: 40 },
	"502": { days: ["2", "3", "4", "5", "6"], hours: 20 },
};

export { weekdays, paymentTypeOptions, salaryPeriodOption, employmentTypeOption, defaultWorking };
